<template>
  <div class="">
    <div
      v-if="type == 'index' || type == 'index5' || type == 'index7'"
      class="dialogBox"
    >
      <!-- <div v-if="false"> -->
      <input
        type="text"
        class="inpTitle"
        autofocus
        :value="floors.topLine"
        placeholder="输入框默认内容"
        nbn
      />
      <div class="floor">
        <el-table
          :data="floors.floors"
          border
          style="width: 100%; margin-top: 20px"
          max-height="800"
        >
          <el-table-column label="楼层" width="180">
            <template slot-scope="scope">
              <div>
                {{ scope.row.name }}
                <el-button
                  class="but"
                  @click="Add(scope.row, scope.$index)"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  size="mini"
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="区域房间">
            <template slot-scope="floor">
              <el-table
                :data="floor.row.zones"
                border
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column label="区域" width="180">
                  <template slot-scope="scope">
                    <div class="not" v-if="scope.row.name == ''">
                      <div style="margin-top: 10px">
                        <div>暂无区域</div>
                      </div>
                    </div>
                    <div v-else>
                      {{ scope.row.name }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="房间">
                  <template slot-scope="room">
                    <div style="display: flex; flex-wrap: wrap">
                      <div v-for="(item, index) in room.row.rooms" :key="index">
                        {{ item }}
                        <span v-if="index + 1 != room.row.rooms.length">/</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <div @click="floorAdd(1)" class="iconAddBox" style="margin-top: 10px">
          <img class="iconAdd" src="../../assets/icon/add.png" alt="" />
          <div>添加楼层</div>
        </div>
        <el-dialog
          title="编辑楼层"
          :visible.sync="addShow"
          width="40%"
          top="15vh"
          :before-close="handleClose"
        >
          <el-form
            ref="ruleForm"
            :model="dataObj"
            label-width="80px"
            :rules="rules"
            v-if="dataObjTrue"
          >
            <el-form-item label="楼层名称" prop="name">
              <div style="width: 20%">
                <el-input
                  v-model="dataObj.name"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="区域房间">
              <div class="dataBox">
                <div
                  class="dataList"
                  v-for="(item, index) in dataObj.zones"
                  :key="index"
                >
                  <div class="dataName">
                    <el-input
                      v-if="item.name"
                      v-model="item.name"
                      placeholder="请输入区域名称"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-delete"
                        type="warning"
                        circle
                        @click="areaDelete(item, index)"
                      ></el-button
                    ></el-input>
                    <el-input
                      v-else
                      v-model="item.name"
                      placeholder="暂无区域"
                    ></el-input>
                  </div>
                  <div class="dataUl">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="请输入房间名称"
                      v-model="item.rooms"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div
                @click="floorAdd(2)"
                class="iconAddBox areaAdd"
                style="margin-top: 10px"
              >
                <img class="iconAdd" src="../../assets/icon/add.png" />
                <div>添加区域</div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >确认编辑</el-button
              ><el-button type="danger" @click="floorDelete()" plain
                >删除楼层</el-button
              >
            </el-form-item>
          </el-form>
          <!-- 新增楼层 -->
          <el-form
            :model="ruleForm"
            label-width="80px"
            :rules="rules"
            ref="addFrom"
            v-else
          >
            <!-- 共有 -->
            <el-form-item label="楼层名称" prop="name">
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="flex" prop="flex">
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.flex"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="isCurrent" prop="isCurrent">
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.isCurrent"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <!-- 区分 -->
            <el-form-item v-if="type == 'index'" label="nostop" prop="nostop">
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.nostop"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              v-if="type == 'index5' || type == 'index7'"
              label="padding"
              prop="padding"
            >
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.padding"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              v-if="type == 'index5' || type == 'index7'"
              label="font"
              prop="font"
            >
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.font"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item
              v-if="type == 'index5'"
              label="floorfont"
              prop="floorfont"
            >
              <div style="width: 30%">
                <el-input
                  v-model="ruleForm.floorfont"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="区域房间">
              <div class="dataBox">
                <div
                  class="dataList"
                  v-for="(item, index) in ruleForm.zones"
                  :key="index"
                >
                  <div class="dataName">
                    <el-input
                      v-model="item.name"
                      placeholder="请输入内容"
                    ></el-input>
                  </div>
                  <div class="dataUl">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="请输入内容"
                      v-model="item.rooms"
                    ></el-input>
                  </div>
                </div>
              </div>
            </el-form-item>
            <div @click="floorAdd(3)" class="iconAddBox areaAdd addAdd">
              <img class="iconAdd" src="../../assets/icon/add.png" />
              <div>添加区域</div>
            </div>
            <el-form-item>
              <el-button type="primary" @click="addSubmitForm('addFrom')"
                >确认新增</el-button
              >
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
    <imgScreen v-else-if="type == 'photo'"></imgScreen>
    <indexScreen v-else></indexScreen>
  </div>
</template>

<script>
import { devices_code, setfloors, content } from "@/uitl/api";
import imgScreen from "@/pages/deviceContent/imgScreen.vue";
import indexScreen from "@/pages/deviceContent/indexScreen.vue";

export default {
  name: "",
  components: {
    imgScreen,
    indexScreen,
  },
  props: {},
  data() {
    return {
      code: "",
      type: "",
      dataObj: {},
      dataObjTrue: false,
      addIndex: 0,
      floors: {},
      ruleForm: {
        name: "",
        flex: "",
        nostop: "",
        isCurrent: "",
        zones: [
          {
            name: "",
            rooms: [],
          },
        ],
      },
      // index7
      // {
      // 				"name": "B2",
      // 				"padding": "26:10",
      // 				"flex": 1,
      // 				"isCurrent": 1
      // 				"zones": [{
      // 					"name": "",
      // 					"rooms": [
      // 						"地下车库:Underground Garage"
      // 					]
      // 				}],
      // 			}

      // index5
      // {
      // 				"name": "B2",
      // 				"floorfont":"8",
      // 				"font": "26:10",
      // 				"flex": 1
      // 				"padding": "2",
      // 				"isCurrent": 1
      // 				"zones": [{
      // 					"name": "",
      // 					"rooms": [
      // 						"地下车库:Underground Garage"
      // 					]
      // 				}],
      // 			}

      addShow: false,
      rules: {
        name: [{ required: true, message: "请输入楼层名称", trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.code = this.$route.query.code;
    this.type = this.$route.query.type;
    console.log(this.code);
    if (
      this.type == "index" ||
      this.type == "index5" ||
      this.type == "index7"
    ) {
      this.addlou();
      if (this.type == "index7") {
        this.ruleForm = {
          name: "",
          font: "",
          flex: 1,
          padding: 0,
          isCurrent: 1,
          zones: [
            {
              name: "",
              rooms: [],
            },
          ],
        };
      }
      if (this.type == "index5") {
        this.ruleForm = {
          name: "",
          floorfont: "",
          font: "",
          flex: 1,
          padding: 0,
          isCurrent: 1,
          zones: [
            {
              name: "",
              rooms: ["地下车库:Underground Garage"],
            },
          ],
        };
      }
    } else if (this.type == "photo") {
    } else {
    }
  },
  methods: {
    Add(data, index) {
      this.addIndex = index;
      this.addShow = true;
      this.dataObjTrue = true;
      this.dataObj = JSON.parse(JSON.stringify(data));
      console.log(this.dataObj, "this.dataObj");
      this.dataObj.zones.forEach((item, index) => {
        item.rooms = item.rooms.toString();
        console.log(item.rooms);
      });
    },

    // 添加
    floorAdd(num, index, oneIndex) {
      // 添加楼层
      if (num == 1) {
        this.addShow = true;
      }
      // 编辑时添加区域
      if (num == 2) {
        console.log(this.dataObj);
        this.dataObj.zones.push({ name: "", rooms: "" });
      }
      if (num == 3) {
        this.ruleForm.zones.push({ name: "", rooms: "" });

        console.log(this.ruleForm);
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.dataObjTrue = false;
          this.ruleForm = {
            name: "",
            zones: [
              {
                name: "",
                rooms: "",
              },
            ],
          };
          this.dataObj = {};
          done();
        })
        .catch((_) => {});
    },
    // 编辑楼层
    areaDelete(data, index) {
      console.log(this.dataObj.zones, index);
      this.$confirm("确认删除该区域以及房间", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dataObj.zones.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataObj.zones.forEach((item) => {
            item.rooms = item.rooms.split(",");
          });
          console.log(this.dataObj, "this.dataObj");
          setfloors(this.code, this.dataObj.name, this.dataObj)
            .then((res) => {
              console.log(res);
              this.$message({
                message: "楼层编辑成功",
                type: "success",
              });
              this.addShow = false;
              this.dataObj = {};
              this.dataObjTrue = false;
              this.addlou();
            })
            .catch((erro) => {
              this.$message.error("楼层编辑失败！" + erro);
            });

          // this.floors.floors[this.addIndex] = JSON.parse(
          //   JSON.stringify(this.dataObj)
          // );
          // this.floors.floors = JSON.parse(JSON.stringify(this.floors.floors));
        } else {
          this.$message.error("楼层编辑失败！");
          return false;
        }
      });
    },
    floorDelete() {
      this.$confirm("确认删除此楼层?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.floors.floors.splice(this.addIndex, 1);
          this.dataObj = {};
          this.addShow = false;
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 新增楼层
    addSubmitForm(addFrom) {
      this.$refs[addFrom].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          this.ruleForm.zones.forEach((item) => {
            item.rooms = item.rooms.split(",");
          });
          this.floors.floors.push(this.ruleForm);
          console.log(this.floors);
          content(this.code, this.floors).then((res) => {
            console.log(res);
          });
          this.$message({
            message: "新增楼层成功",
            type: "success",
          });
          this.addShow = false;
          this.ruleForm = {
            name: "",
            zones: [
              {
                name: "",
                rooms: "",
              },
            ],
          };
        } else {
          this.$message.error("新增楼层失败！");
          return false;
        }
      });
    },
    addlou() {
      devices_code(this.code).then((res) => {
        this.floors = res.data.content;
        content(this.code, this.floors).then((res) => {
          console.log(res);
        });
        // console.log(this.floors, "res.content");
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialogBox {
  width: 100%;
  box-sizing: border-box;

  .floor {
    height: 95%;
    height: 100%;
    overflow: auto;
    .but {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }
}

.inpTitle {
  width: 50%;
  font-size: 22px;
  border: 0px;
  /*去除所有边框*/
  outline: none;
  /*去除选中时出现的边框*/
  border-bottom-color: black;
  /*下边框颜色*/
  border-bottom-left-radius: 0px;
  /*下左边框的圆角为0px*/
  border-bottom-right-radius: 0px;
  /*下右边框的圆角为0px*/
  border-bottom-width: 0.2px;
  /*下边框的宽度*/
  border-bottom-style: solid;
  /*下边框的样式 solid-->实线*/
}

.not {
  color: #e0dfdf;
  font-style: italic;
}

.iconAddBox {
  display: flex;
  width: 100px;
  height: 20px;
  line-height: 20px;

  .iconAdd {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.areaAdd {
  position: absolute;
  right: 8%;
  bottom: -20px;
}
.addAdd {
  bottom: 90px;
}
.dataBox {
  width: 100%;
  .dataList {
    display: flex;
    margin-bottom: 10px;
    width: 100%;
    .dataName {
      width: 20%;
    }
    .dataUl {
      margin-left: 2%;
      width: 70%;
    }
  }
}
</style>
